import { render } from "./PublicReviewGenerate.vue?vue&type=template&id=56f2a97e"
import script from "./PublicReviewGenerate.vue?vue&type=script&lang=js"
export * from "./PublicReviewGenerate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__